import { atom } from "recoil";

const howLinkAtom = atom({
  key: "howLinkState",
  default: false,
});

export default howLinkAtom;
